import { HttpClient } from '../../httpClient'
import { throwIfNotAllowedContentType, validateHttpResponse } from '../../httpClient/utils.ts'
import { IOrganizationUser } from './interfaces.ts'

export interface IOrganizationUsersFilter {
	managerId?: string
	isManager?: boolean
	positionId?: string
	role?: string
	page?: number
	size?: number
	includes?: string[]
}

export const getOrganizationUsersV2 = async (
	client: HttpClient,
	organizationId: string,
	filters?: IOrganizationUsersFilter
): Promise<IOrganizationUser[]> => {
	const response = await client.get<IOrganizationUser[]>(`/api/v2/organizations/${organizationId}/users`, {
		params: {
			...filters,
			includes: filters?.includes ? filters.includes.join(',') : undefined,
		},
	})

	await validateHttpResponse(response)
	throwIfNotAllowedContentType(response, ['application/json'])

	return response.data
}
